/**
 * Barrel export for InlineEditableInfoPanel
 */

export { InlineEditableInfoPanel } from "./InlineEditableInfoPanelMain";
export type { InlineEditableInfoPanelProps } from "./types";
